import React from "react"
import { FaBars } from "react-icons/fa"
import PageLinks from "../constants/links"
import logo from "../assets/Logo_GU-color.jpg"

const Navbar = ({ toggleSidebar }) => {
  return (
    <nav className="navbar">
      <div className="nav-center">
        <div className="nav-header">
          <img src={logo} alt="logo" className="logo" />
          <button type="button" className="toggle-btn" onClick={toggleSidebar}>
            <FaBars></FaBars>
          </button>
        </div>
        <PageLinks styleClass="nav-links"></PageLinks>
      </div>
    </nav>
  )
}

export default Navbar
